
import { ReactNode } from "react";
import { Check } from "lucide-react";

interface Feature {
  title: string;
  description: string;
}

interface SecurityCardProps {
  icon: React.ElementType;
  title: string;
  description: string;
  features: Feature[];
  testimonial: string;
  testimonialAuthor: string;
}

export const SecurityCard = ({
  icon: Icon,
  title,
  description,
  features,
  testimonial,
  testimonialAuthor,
}: SecurityCardProps) => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-8 border border-gray-100 hover:shadow-md transition-all duration-300 hover:border-edgefi-purple/20 hover:-translate-y-1 group">
      <div className="mb-6 w-14 h-14 rounded-full bg-edgefi-purple/10 flex items-center justify-center group-hover:bg-edgefi-purple/20 transition-colors duration-300">
        <Icon className="h-7 w-7 text-edgefi-purple" />
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-4">{title}</h3>
      <p className="text-gray-600 mb-6">
        {description}
      </p>
      
      <div className="space-y-4">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start gap-3">
            <Check className="h-5 w-5 text-edgefi-purple mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-gray-800 font-medium">{feature.title}</p>
              <p className="text-gray-600 text-sm mt-1">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="pt-6 mt-6 border-t border-gray-100">
        <p className="text-gray-600 italic">
          "{testimonial}" 
          <span className="text-sm not-italic block mt-2">— {testimonialAuthor}</span>
        </p>
      </div>
    </div>
  );
};
